module.exports = __webpack_public_path__ + "img/install-extension-banner.8c1bf49e.png";